export default __webpack_public_path__ + "6d3643b191aba5b41fb06896abb47384.svg";